import { useEffect, useState } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import MyInput from "../../Components/Myinput";
import MyButton from "../../Components/MyButton";
import API from "../../Api/axiosConfig";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { faEye, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";

import ModalForm from "../../Components/ModalForm";
import Can from "../../Components/Can";
import { useAuth } from "../../context/AuthContext";

function Salary() {
  const { user } = useAuth();
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const todayDate = today.toISOString().slice(0, 10);
  const [data, setData] = useState(null);

  const [filters, setFilters] = useState({
    year: "",
    month: "",
    date: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [currentUuid, setCurrentUuid] = useState(null);

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState(null); // all | one
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cashType, setCashType] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [storeCreatedAt, setStoreCreatedAt] = useState(null);
  const fetchUserData = () => {
    API.get("/user")
      .then((res) => {
        const createdAt = res.data.data.store.created_at;
        setStoreCreatedAt(new Date(createdAt));
        setData(res.data);
      })
      .catch((err) => {
        console.error("فشل تحميل بيانات المتجر", err);
      });
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const getLastDayOfMonth = (year, month) =>
    new Date(year, month, 0 + 1).toISOString().slice(0, 10);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };

    if (newFilters.year && newFilters.month) {
      const y = parseInt(newFilters.year);
      const m = parseInt(newFilters.month);

      if (y > currentYear || (y === currentYear && m > currentMonth)) {
        newFilters.date = "";
      } else if (y === currentYear && m === currentMonth) {
        newFilters.date = todayDate;
      } else {
        newFilters.date = getLastDayOfMonth(y, m);
      }
    } else {
      newFilters.date = "";
    }

    setFilters(newFilters);
  };

  const handleSearch = () => {
    if (!filters.year || !filters.month) {
      toast.error("من فضلك اختر السنة والشهر أولاً");
      return;
    }
    if (!filters.date) {
      toast.error("لا يمكن اختيار تاريخ مستقبلي");
      return;
    }
    setAppliedFilters(filters);
    setRefreshKey((prev) => prev + 1);
  };

  const handlePayAllConfirm = () => {
    setConfirmType("all");
    setShowConfirm(true);
  };

  const handlePayOneConfirm = (uuid) => {
    setSelectedUuid(uuid);
    setConfirmType("one");
    setShowConfirm(true);
  };

  // const handleConfirmAction = async () => {
  //     setLoading(true);
  //     try {
  //         if (confirmType === "all") {
  //             const res = await API.post("/salary-all", { date: appliedFilters.date });
  //             console.log(res.data.message || "تم صرف المرتب للجميع");
  //         } else if (confirmType === "one") {
  //             const res = await API.post("/salary-one", {
  //                 employee_uuid: selectedUuid,
  //                 date: appliedFilters.date,
  //             });
  //             console.log(res.data.message || "تم صرف المرتب للموظف");
  //         }
  //         setRefreshKey((prev) => prev + 1);
  //         setShowConfirm(false);
  //     } catch (error) {
  //         console.log(error.response?.data?.message || "فشل صرف المرتب");
  //     } finally {
  //         setLoading(false);
  //     }
  // };

  const handleConfirmAction = async () => {
    setLoading(true);
    try {
      if (confirmType === "all") {
        await API.post("/salary-all", {
          date: appliedFilters.date,
          cash_type: cashType,
        });
      } else if (confirmType === "one") {
        await API.post("/salary-one", {
          employee_uuid: selectedUuid,
          date: appliedFilters.date,
          cash_type: cashType,
        });
      }
      setRefreshKey((prev) => prev + 1);
      setShowConfirm(false);
      fetchUserData();
    } catch (error) {
      console.log(error.response?.data?.message || "فشل صرف المرتب");
    } finally {
      setLoading(false);
    }
  };
  const handleOpenUploadModal = (uuid) => {
    setCurrentUuid(uuid);
    setShowUploadModal(true);
  };
  const handleUploadImage = async () => {
    if (!selectedImage) {
      toast.error("من فضلك اختر صورة أولاً");
      return;
    }

    if (!currentUuid) {
      toast.error("لم يتم تحديد الموظف");
      return;
    }

    const formData = new FormData();
    formData.append("image", selectedImage);

    try {
      const res = await API.post(`/salary/image/${currentUuid}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success(res.data.message || "تم رفع الصورة بنجاح");
      handleCloseUploadModal();
      setSelectedImage(null);
    } catch (error) {
      toast.error(error.response?.data?.message || "فشل رفع الصورة");
    }
  };

  const handleCloseUploadModal = () => setShowUploadModal(false);
  const columns = [
    { header: "الاسم", accessor: "name" },
    { header: "الراتب الأساسي", accessor: "basic_salary" },
    { header: "إجمالي المكافآت", accessor: "total_rewards" },
    { header: "إجمالي الخصومات", accessor: "total_discounts" },
    { header: "إجمالي المسحوبات", accessor: "total_withdrawals" },
    { header: "الراتب الصافي", accessor: "net_salary" },
    {
      header: "الحالة",
      accessor: (row) => (
        <span
          className={`${row.is_paid ? "fw-bold text-is-paid" : "text-color"}`}>
          {row.is_paid ? "تم الصرف" : "لم يصرف"}
        </span>
      ),
    },
    {
      header: "الإجراءات",
      accessor: (row) => (
        <div className="d-flex justify-content-between gap-3">
          <button className="btn btn-sm me-1" title="عرض التفاصيل">
            <Link
              to={`/salary-details/${row.uuid}`}
              className="btn btn-sm btn-info me-1 border-0"
              title="عرض التفاصيل"
              style={{ background: "#6c757d" }}>
              <FontAwesomeIcon icon={faEye} />
            </Link>
          </button>

          {!row.is_paid && (
            <Can permission="salary_create">
              <MyButton
                text="صرف"
                size="sm"
                onClick={() => handlePayOneConfirm(row.uuid)}
              />
            </Can>
          )}

          {/* أيقونة رفع صورة */}
          <button
            className="btn btn-sm btn-secondary"
            title="رفع صورة"
            onClick={() => handleOpenUploadModal(row.uuid)}>
            <FontAwesomeIcon icon={faUpload} />
          </button>
        </div>
      ),
      hideOnPrint: true,
    },
  ];

  let years = [];
  let months = [];

  if (storeCreatedAt) {
    const startYear = storeCreatedAt.getFullYear();
    const startMonth = storeCreatedAt.getMonth() + 1;

    years = Array.from(
      { length: currentYear - startYear + 1 },
      (_, i) => startYear + i
    );

    months = [
      { value: 1, label: "يناير" },
      { value: 2, label: "فبراير" },
      { value: 3, label: "مارس" },
      { value: 4, label: "إبريل" },
      { value: 5, label: "مايو" },
      { value: 6, label: "يونيو" },
      { value: 7, label: "يوليو" },
      { value: 8, label: "أغسطس" },
      { value: 9, label: "سبتمبر" },
      { value: 10, label: "أكتوبر" },
      { value: 11, label: "نوفمبر" },
      { value: 12, label: "ديسمبر" },
    ];

    months = months.filter((m) => {
      if (filters.year === String(startYear) && m.value < startMonth)
        return false;
      if (filters.year === String(currentYear) && m.value > currentMonth)
        return false;
      return true;
    });
  }

  return (
    <div className="container mt-5 ">
      <Mytitle title="كشف الرواتب" />

      <div className="container mb-3">
        <div className="row">
          <div className="d-flex justify-content-between align-items-center direction-rtl flex-wrap ">
            <div className="d-flex flex-wrap mb-2">
              <div className="me-2" style={{ width: "200px" }}>
                <MyInput
                  as="select"
                  name="year"
                  value={filters.year}
                  onChange={handleChange}
                  options={[
                    { value: "", label: "اختر السنة" },
                    ...years.map((y) => ({ value: y, label: y })),
                  ]}
                />
              </div>

              <div className="me-2" style={{ width: "200px" }}>
                <MyInput
                  as="select"
                  name="month"
                  value={filters.month}
                  onChange={handleChange}
                  disabled={!filters.year}
                  options={[
                    { value: "", label: "اختر الشهر" },
                    ...months.map((m) => ({
                      value: m.value,
                      label: m.label,
                    })),
                  ]}
                />
              </div>

              <div className="d-flex align-items-center mx-3">
                <MyButton onClick={handleSearch} text="بحث" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {appliedFilters && (
        <>
          <div className="mb-3 text-center">
            <h5 style={{ color: "white" }}>
              كشف الرواتب لشهر{" "}
              {
                months.find((m) => m.value === parseInt(appliedFilters.month))
                  ?.label
              }{" "}
              {appliedFilters.year}
            </h5>
          </div>
          <MyTable
            resource="salaryBefore"
            method="post"
            title={"كشف الرواتب"}
            body={{ date: appliedFilters.date }}
            columns={columns}
            refreshKey={refreshKey}
            // button={{
            //   text: "صرف الكل",
            //   onClick: handlePayAllConfirm,
            //   variant: "success",
            //   permission: "salary_create",
            // }}

            // isCompanySealOrLogoPrinted = {{logo: data.data.setting.company_logo, }}
          />
        </>
      )}

      <ModalForm
        show={showUploadModal}
        onClose={() => {
          handleCloseUploadModal();
          setSelectedImage(null);
          URL.revokeObjectURL(previewUrl);
        }}
        title="رفع صورة للراتب"
        onSubmit={handleUploadImage}
        loading={loading}
        mode="upload"
        confirmText="تحميل"
        cancelText="إلغاء">
        <div className="mb-3 text-center">
          <input
            type="file"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                setSelectedImage(file);
                setPreviewUrl(URL.createObjectURL(file)); // ✅ أنشئ رابط مؤقت
              }
            }}
            className="form-control mb-3"
          />

          {previewUrl && (
            <div className="mt-3">
              <img
                src={previewUrl} // ✅ استخدم الرابط المؤقت
                alt="preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "250px",
                  borderRadius: "10px",
                  border: "1px solid #ccc",
                  objectFit: "contain",
                }}
              />
            </div>
          )}
        </div>
      </ModalForm>
      <ModalForm
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
        title="تأكيد الصرف"
        onSubmit={handleConfirmAction}
        loading={loading}
        mode="confirm"
        confirmText="نعم"
        cancelText="إلغاء">
        {confirmType === "all"
          ? "هل أنت متأكد من صرف المرتب لجميع الموظفين؟"
          : "هل أنت متأكد من صرف المرتب لهذا الموظف؟"}

        <div className="mb-3">
          <MyInput
            as="select"
            value={cashType}
            onChange={(e) => setCashType(e.target.value)}
            options={[
              { value: "", label: "إختر الخزنة" },
              { value: "cash", label: "كاش" },
              { value: "bank", label: "بنك" },
            ]}
          />
        </div>
        {cashType === "cash" && (
          <div className="text-muted mb-2" style={{ direction: "rtl" }}>
            الرصيد المتاح في الكاش:{" "}
            <strong>{Math.trunc(data?.data.last_cash_balance) ?? 0}</strong>
          </div>
        )}
        {cashType === "bank" && (
          <div className="text-muted mb-2" style={{ direction: "rtl" }}>
            الرصيد المتاح في البنك:{" "}
            <strong>{Math.trunc(data?.data.last_bank_balance ?? 0)}</strong>
          </div>
        )}
      </ModalForm>
    </div>
  );
}

export default Salary;
